import { render } from "./SeoParentRow.vue?vue&type=template&id=4bbf9f71&scoped=true"
import script from "./SeoParentRow.vue?vue&type=script&lang=js"
export * from "./SeoParentRow.vue?vue&type=script&lang=js"

import "./SeoParentRow.vue?vue&type=style&index=0&id=4bbf9f71&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbf9f71"]])

export default __exports__